import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import { LINK_VATRATES } from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const VATratesListView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.VATRATES)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (
      <OptionsField
        attr={attr}
        val={row[attr]}
        options={store.options.get('Countries')}
        labelattr='text'
        valueattr='value'
        Component={({ text }) => (
          <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
        )}
      />
    ),
    (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={5} />),
    (attr, row) => (
      <OptionsField
        attr={attr}
        val={row[attr]}
        options={store.options.get('Platforms')}
        labelattr='text'
        valueattr='value'
      />
    ),
    (attr, row) => (<DateField attr={attr} val={row[attr]} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }
  const filters = {
    'id_like': {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    'region_like': {
      title: 'Region',
      component: (props) => (<TextInput {...props} />)
    },
    'rate': {
      title: 'rate',
      component: (props) => (<TextInput {...props} />)
    },
    'platform_like': {
      title: 'platform',
      component: (props) => (<TextInput {...props} />)
    },
    'valid_from__from': {
      title: 'valid from',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    'valid_to__from': {
      title: 'valid to',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    }
  }

  // TODO: remove initOrder
  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_VATRATES)}
    initOrder={{
      'region': 'desc'
    }}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />
  )
}
export default observer(VATratesListView)
